import { createSlice } from "@reduxjs/toolkit";

export const reporteEncuestaSlices = createSlice({
  name: "reporte",
  initialState: {
    value: {
      limit: 10,
      offset: 0,
      order: "",
      orientation: "",
      survey: "",
      guest: "",
      start_date: "",
      end_date: "",
      user: "",
      status: [],
      sample_id: "",
      key: "",
    },
    total: 10,
    offsetP: 10,
    fila: 0,
    estado: true,
    page: 0,
    surveyPD: [],
  },
  reducers: {
    changeEvento: (state, action) => {
      //
      state.value.order = action.payload.name;
      state.value.orientation = action.payload.direction;
    },
    changeLimit: (state, action) => {
      //
      state.value.limit = action.payload;
      state.value.offset = state.value.fila * state.value.limit;
    },

    changeOffset: (state, action) => {
      //
      state.value.fila = action.payload;
      state.value.offset = state.value.fila * state.value.limit;
    },
    changeData: (state, action) => {
      //
      state.value.search = action.payload;
    },
    changeSurvey: (state, action) => {
      //
      state.value.survey = action.payload;
    },
    key: (state, action) => {
      //
      state.value.key = action.payload;
    },

    changeGuest: (state, action) => {
      //
      state.value.guest = action.payload;
    },
    changeFechIni: (state, action) => {
      //
      state.value.start_date = action.payload;
    },
    changeFechFin: (state, action) => {
      //
      state.value.end_date = action.payload;
    },
    changeUser: (state, action) => {
      //
      state.value.user = action.payload;
    },
    changeStatus: (state, action) => {
      //
      state.value.status = action.payload;
    },
    changeTotal: (state, action) => {
      //
      state.total = action.payload;
    },
    changeOffsetP: (state, action) => {
      //
      state.offsetP = action.payload;
    },
    changeEstado: (state, action) => {
      //
      state.estado = action.payload;
    },
    changePages: (state, action) => {
      //
      state.page = action.payload;
    },
    changeSampleId: (state, action) => {
      //
      state.value.sample_id = action.payload;
    },
    changeFila: (state, action) => {
      //
      state.fila = action.payload;
    },
    surveyPD: (state, action) => {
      //
      state.surveyPD = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  changeEvento,
  changeLimit,
  changeOffset,
  changeData,
  changeTotal,
  changeOffsetP,
  changeSurvey,
  changeGuest,
  changeStatus,
  changeEstado,
  changeFechIni,
  changeFechFin,
  changeUser,
  changeFila,
  changePages,
  changeSampleId,
  surveyPD,
  key,
} = reporteEncuestaSlices.actions;

export default reporteEncuestaSlices.reducer;
